<div class="container" [ngSwitch]="mode">
  <div *ngSwitchDefault>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width:100%">
      <tr  class="back">
        <th>Name</th>
        <th>Status</th>
        <th>
          <button class="add" mat-raised-button color="basic" (click)="addNew()">
            Add New
          </button>
        </th>
      </tr>
      <tr class="td" *ngFor="let title of titles">
        <td>{{title.name}}</td>
        <td>{{title.status}}</td>
        <td>
          <button mat-raised-button color="primary" (click)=" edit(title)">
            Edit
          </button>
          <button mat-raised-button color="primary" style="margin-left: 5px;" (click)="delete(title)">
            Delete
          </button>
        </td>
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
          <p>{{Errors}}</p>
      </div>
    </div>
    <div class="last">
    </div>
  </div>

  <form [formGroup]="deptForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'add'">
    <div class="post">
      <div class="title">Create Department</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
              <mat-label>Name</mat-label>
              <input formControlName="name" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Print Name</mat-label>
              <input formControlName="print_name" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select formControlName="status" matNativeControl required>
                <mat-option value="Active">Active</mat-option>
                <mat-option value="Inctive">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
      </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
            <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading? "Saving...": "Save"}}
        </button>
      </div>
    </div>
  </form>
  <form [formGroup]="deptForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'edit'">
    <div class="post">
      <div class="title">Edit Department</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
              <mat-label>Name</mat-label>
              <input formControlName="name" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Print Name</mat-label>
              <input formControlName="print_name" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select formControlName="status" matNativeControl required>
                <mat-option value="Active">Active</mat-option>
                <mat-option value="Inctive">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
      </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
            <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading? "Saving...": "Save"}}
        </button>
      </div>
    </div>
  </form>
    
  </div>